export default "__VITE_ASSET__2b5854ae__"